import BlogPage from "./modules/blog/BlogPage.svelte";

const app = new BlogPage({
	target: document.getElementById("blog-page"),
	props: {
		pageConfig: window['pageConfig']
	}
});

export default app;